import { BoughtEbookTable } from './BoughtEbookTable'
import { withBoughtEbookTable } from './withBoughtEbookTable'

const ConnectedBoughtEbookTable = withBoughtEbookTable(BoughtEbookTable)

export { ConnectedBoughtEbookTable as BoughtEbookTable }
